import React from "react";
import { SectionLabel, Reveal } from "@/lib/uiHelpers";
import { TESTIMONIALS } from "@/constants/landingCopy";
import { Star, ThumbsUp } from "lucide-react";

function Stars({ count = 5 }) {
  return (
    <span className="inline-flex items-center gap-0.5" aria-label={`${count} star rating`}>
      {Array.from({ length: count }).map((_, i) => (
        <Star key={`star-${i}`} size={15} fill="#F5A623" stroke="#F5A623" />
      ))}
    </span>
  );
}

function Card({ t, feature }) {
  return (
    <div
      className={`h-full rounded-2xl p-6 md:p-7 ${feature ? "md:col-span-2" : ""}`}
      style={{
        background: "#F4F0E8",
        borderLeft: "4px solid #F5A623",
        boxShadow: "0 16px 38px -28px rgba(26,43,74,0.3)",
      }}
    >
      <p
        className={`font-body italic text-[#2C3E50] ${feature ? "text-lg md:text-xl" : "text-base"}`}
      >
        &ldquo;{t.quote}&rdquo;
      </p>
      <div className="mt-5 flex flex-wrap items-center gap-x-3 gap-y-1">
        <span className="font-head font-bold" style={{ color: "#1A2B4A" }}>
          &mdash; {t.name}
        </span>
        {t.recommends ? (
          <span className="inline-flex items-center gap-1.5 text-sm font-semibold" style={{ color: "#27AE60" }}>
            <ThumbsUp size={15} /> {t.source}
          </span>
        ) : (
          <span className="inline-flex items-center gap-2 text-sm" style={{ color: "#7F8C8D" }}>
            <Stars count={t.rating || 5} /> {t.source}
          </span>
        )}
      </div>
    </div>
  );
}

export default function Testimonials() {
  return (
    <section className="section-pad" style={{ backgroundColor: "#FAFAF8" }}>
      <div className="container-max">
        <Reveal className="text-center max-w-2xl mx-auto">
          <SectionLabel>What Maui Homeowners Are Saying</SectionLabel>
          <h2 className="font-head font-extrabold text-3xl md:text-5xl" style={{ color: "#1A2B4A" }}>
            Real Results. Real Neighbors. Real Maui.
          </h2>
        </Reveal>

        <div className="mt-12 grid md:grid-cols-2 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.name} delay={(i % 2) * 0.08} className={t.feature ? "md:col-span-2" : ""}>
              <Card t={t} feature={t.feature} />
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1} className="mt-10">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-5 text-center">
            <span className="inline-flex items-center gap-2 font-head font-bold" style={{ color: "#1A2B4A" }}>
              <Stars count={5} /> 5.0 Google Rating
            </span>
            <span className="hidden sm:inline" style={{ color: "#cfc9bd" }}>|</span>
            <span className="font-body" style={{ color: "#7F8C8D" }}>Recommended on Facebook</span>
            <span className="hidden sm:inline" style={{ color: "#cfc9bd" }}>|</span>
            <span className="font-body" style={{ color: "#7F8C8D" }}>Maui&apos;s Trusted Solar Team</span>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
